import { RepriceQuoteButtonNext } from 'components/common-form/sidePanel/actions/quote/RepriceQuoteButtonNext';
import { ConnectedSolveResult } from 'components/common-form/sidePanel/status/stream/SolveResult';
import { connectStream, StreamingProps } from 'components/common-form/sidePanel/status/stream/Stream.connect';
import { ConnectedUnderlying } from 'components/common-form/sidePanel/status/stream/Underlying';
import { PricedOn } from 'components/shared/Price/Price';
import { WaitingPrice } from 'components/shared/Price/WaitingPrice';
import { ConnectedTradeWayLiteral, PriceNext, QuoteStatus } from 'components/shared/PriceNext';
import { useProgressTimer } from 'hooks/useProgressTimer';
import { useCallback, useContext } from 'react';
import { logAnalytics } from 'shared/middlewares/analytics/logger';
import { WorkspaceAnalyticCategoryContext } from 'shared/middlewares/analytics/loggerContext';

import { SolveModeLabel } from '../../SolveMode';

function StreamExpired({
  workspaceType,
  quoteRequestStartingTimeInMillis,
  estimatedQuotingDurationInMillis = 120000,
  solvingMode,
  children,
  tabId,
  pricedOn,
  onQuoteCancelled,
}: StreamingProps) {
  const { progressInPercent } = useProgressTimer(quoteRequestStartingTimeInMillis, estimatedQuotingDurationInMillis);
  const logAnalyticsCategory = useContext(WorkspaceAnalyticCategoryContext);
  const onCancel = useCallback(() => {
    logAnalytics.trackEvent(logAnalyticsCategory, 'Cancel quote (From status)');
    onQuoteCancelled();
  }, [onQuoteCancelled, logAnalyticsCategory]);

  if (workspaceType === 'static' || workspaceType === 'dynamic') {
    return (
      <PriceNext
        className="bg-warning text-warning bg-opacity-10"
        tradeWay={<ConnectedTradeWayLiteral tabId={tabId} workspaceType={workspaceType} />}
        solveMode={
          <SolveModeLabel workspaceType={workspaceType} solvingMode={solvingMode} isMultipleSolvingMode={false} />
        }
        fxSpot={<ConnectedUnderlying formId={tabId} />}
        solveResult={<ConnectedSolveResult formId={tabId} />}
        quoteStatus={
          <QuoteStatus
            className="alert alert-warning"
            icon="history_toggle_off"
            description="sidePanel.quoteStatus.streamExpired"
            action={<RepriceQuoteButtonNext tabId={tabId} workspaceType={workspaceType} />}
          />
        }
        pricedOn={<PricedOn className="fs-12" pricedOn={pricedOn} />}
      />
    );
  }

  return (
    <WaitingPrice
      color={'success'}
      onCancel={onCancel}
      progressInPercent={progressInPercent}
      topRightActions={children}
    />
  );
}

export const StreamExpiredComponent = connectStream(StreamExpired);
